import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicyPage = () => {
  return (
    <div className="bg-zinc-950 grid-background min-h-screen text-zinc-100 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-invert prose-zinc max-w-none"
        >
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Privacy Policy</h1>
          <p className="text-zinc-400 mb-12">How Doora processes personal data and protects your rights.<br/>Last updated: April 7, 2026</p>

          <p>This privacy policy explains how we process personal data when you use our website. How we collect and use personal data depends on how you interact with us and which services you use. We only process personal data if we have a legitimate purpose and legal basis to do so.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">1. Who We Are</h2>
          <p>The controller within the meaning of the General Data Protection Regulation and other applicable data protection laws is:</p>
          <p>PT Neuronworks Indonesia</p>
          <p>Email: <a href="mailto:support@neuronworks.co.id" className="text-blue-400 hover:underline">support@neuronworks.co.id</a></p>
          <p>Website: <a href="https://www.doora.id/" className="text-blue-400 hover:underline">www.doora.id</a></p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">2. Legal Bases for Processing</h2>
          <ul className="list-disc pl-6 space-y-4 mb-4">
            <li><strong>Consent (Art. 6(1)(a) GDPR)</strong>: You have given consent for the processing of your personal data for a specific purpose. You may withdraw consent at any time.</li>
            <li><strong>Contract (Art. 6(1)(b) GDPR)</strong>: Processing is necessary for the performance of a contract or to take steps before entering into a contract.</li>
            <li><strong>Legal obligation (Art. 6(1)(c) GDPR)</strong>: Processing is necessary to comply with legal obligations.</li>
            <li><strong>Legitimate interests (Art. 6(1)(f) GDPR)</strong>: Processing is necessary for our legitimate interests unless overridden by your interests or fundamental rights.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-4">3. Data Sharing and International Transfers</h2>
          <p>We work with service providers who help us operate our website and provide our services. When required, personal data may be shared with these providers.</p>
          <p>If personal data is transferred outside the European Union, we ensure appropriate safeguards such as Standard Contractual Clauses or the European Union-United States Data Privacy Framework where applicable.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">4. Your Rights</h2>
          <p>Under the General Data Protection Regulation you have the following rights:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Right of access (Art. 15 GDPR)</li>
            <li>Right to rectification (Art. 16 GDPR)</li>
            <li>Right to restriction of processing (Art. 18 GDPR)</li>
            <li>Right to erasure (Art. 17 GDPR)</li>
            <li>Right to data portability (Art. 20 GDPR)</li>
            <li>Right to object to processing (Art. 21 GDPR)</li>
            <li>Right to lodge a complaint with a supervisory authority</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-4">5. Provision of the Website and Log Files</h2>
          <p>When visiting our website, our system automatically collects technical information from your device including:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>browser type and version</li>
            <li>operating system</li>
            <li>date and time of access</li>
            <li>referring websites</li>
            <li>location or country and screen size</li>
          </ul>
          <p>These data are stored in server log files and are not combined with other personal data.</p>
          <p><strong>Purpose of processing:</strong> To ensure the functionality and security of the website.</p>
          <p><strong>Legal basis:</strong> Art. 6(1)(f) GDPR (legitimate interest).</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">6. Use of Cookies</h2>
          <p>We use cookies and similar technologies on our website. Cookies are small text files stored on your device.</p>
          <p>Technically necessary cookies are required for the functionality of the website. Non-essential cookies may process data such as IP address, location, browsing behavior, and time of visit.</p>
          <p>Purpose of non-essential cookies: analyze user behavior, improve usability, measure reach of our services, optimize website content.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">7. Email Contact and Contact Form</h2>
          <p>If you contact us via email or our contact form, personal data transmitted will be stored solely for the purpose of responding to your request and ensuring the security of our IT systems.</p>
          <p><strong>Legal basis:</strong> Art. 6(1)(f) GDPR or Art. 6(1)(b) GDPR if the request relates to a contract.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">8. Applications by Email</h2>
          <p>Applicants may submit job applications via email. The data contained in the application will be processed exclusively for the recruitment process.</p>
          <p><strong>Legal basis:</strong> Art. 6(1)(b) GDPR.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">9. Third-Party Services</h2>
          <p>Our website and services may utilize third-party infrastructure and service providers, including cloud hosting providers and content delivery networks. This processing is based on our legitimate interest (Art. 6(1)(f) GDPR) to improve performance and security.</p>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
